import React from 'react'
import { observer } from 'mobx-react'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import Button from 'ui/buttons/Button'
import { Translation } from '@morningtrain/react-translations'
import { ExecuteOperationForModelOnPipe, ExecuteOperationOnPipe, SubmitFormOnPipe } from '@morningtrain/react-resources'

function Publish () {
  return (
    <Pipeline>
      <TriggerPipelineOnClick>
        <Button>
          <Translation name="generic.publish" defaultValue="Publish"/>
        </Button>
      </TriggerPipelineOnClick>
      <SubmitFormOnPipe data={{ action: 'publish' }}/>
      <Pipeline nested async>
        <ExecuteOperationOnPipe operationName="index"/>
        <ExecuteOperationForModelOnPipe operationName="read"/>
      </Pipeline>
    </Pipeline>

  )
}

export default observer(Publish)
